// src/utils/authUtils.js
import { fetchAuthSession } from "aws-amplify/auth";

export const getIdToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString(); // Cognitoオーソライザー用
  } catch (error) {
    console.error("JWT取得失敗:", error);
    return null;
  }
};